import { useState } from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Alert, AlertDescription } from '@/components/ui/alert'
import { RefreshCw, Info } from 'lucide-react'
import { PreviewIframe } from './PreviewIframe'
import type { WidgetConfiguration } from '../../types'

interface WidgetPreviewProps {
  config: WidgetConfiguration
  tenantSlug: string
}

export function WidgetPreview({ config, tenantSlug }: WidgetPreviewProps) {
  const [refreshKey, setRefreshKey] = useState(0)

  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1)
  }

  return (
    <Card className="h-full">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            Widget Preview
          </CardTitle>
          <Button
            variant="outline"
            size="sm"
            onClick={handleRefresh}
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Refresh
          </Button>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <Alert>
          <Info className="h-4 w-4" />
          <AlertDescription>
            Changes update automatically. The widget appears in the bottom-right corner of the preview.
          </AlertDescription>
        </Alert>

        <div className="border rounded-lg overflow-hidden" style={{ height: '750px' }}>
          <PreviewIframe key={refreshKey} config={config} tenantSlug={tenantSlug} />
        </div>
      </CardContent>
    </Card>
  )
}
